<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="refresh-loco-status">
    <div class="loco-status-page-label">
        <strong>{{configData && configData.locoStatusLabel.locoStatus}}</strong>
    </div>
    <button id="defaultSearchButton" tabindex="{{tabIndex}}" type="button" (click)="refreshLocoStatus()">
              <i class='fa fa-refresh'></i></button>
    <div class="last-refresh">
        <p>{{configData && configData.locoStatusLabel.lastRefresh}}</p>
        <span><strong>{{lastRefreshTime ? lastRefreshTime : 'N/A'}}</strong></span>
    </div>
    <lms-tabs [tabs]="tabs" [editMode]="editMode?.status" (lmsTabChange)="lmsEventHandler($event)"></lms-tabs>
</div>